<!--
 * @Author: LiuMeiYu
 * @Date: 2023-02-01 21:09:51
 * @LastEditors: LiuMeiYu
 * @LastEditTime: 2023-02-09 09:35:14
 * @FilePath: \Nivara\src\views\set\setView.vue
 * @Description: *
 * *
 * Copyright (c) 2023 by yihua, All Rights Reserved.
-->
<template>
  <div class="set-container">
    <div class="set-content">
      <div class="set-type-box">
        <div class="set-type-title">Settings</div>
        <div class="set-item-box">
          <div
            class="set-item"
            :class="setType == index ? 'active' : ''"
            @click="setType = index"
            v-for="(item, index) in setTypeListData"
            :key="index"
          >
            {{ item }}
          </div>
        </div>
      </div>
      <div class="set-type-content">
        <SetProfile v-if="!setType"></SetProfile>
        <SetSecurity v-else></SetSecurity>
      </div>
    </div>
  </div>
</template>
<script>
import { defineComponent, onMounted, reactive, ref, toRefs } from "@vue/runtime-core";
import SetProfile from "./components/setProfileView.vue";
import SetSecurity from "./components/setSecurityView.vue";
import bus from "../../utils/eventBus"

export default defineComponent({
  name: "Set",
  components: {
    SetProfile,
    SetSecurity,
  },
  setup() {
    onMounted(() => {
      bus.emit("changeTitle", "Setting");
    });
    const setType = ref(0);
    const state = reactive({
      setTypeListData: ["My Profile", "Security Settings"],
    });
    return { setType, ...toRefs(state) };
  },
});
</script>

<style lang="less" scoped>
.set-container {
  min-height: 800px;
  display: flex;
  justify-content: center;
  padding: 20px 0;
  background-color: #f7f7f7;
  .set-content {
    display: flex;
    .set-type-box {
      width: 217px;
      min-width: 217px;
      padding: 20px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
      .set-type-title {
        padding-bottom: 20px;
        text-align: left;
        font-size: 16px;
        color: #000000;
        font-weight: bold;
        border-bottom: 1px solid #dfdfdf;
      }
      .set-item-box {
        .set-item {
          margin-top: 10px;
          padding: 13px 0;
          font-size: 14px;
          background-color: #efefef;
          color: #03004d;
          border-radius: 12px;
          cursor: pointer;
          &.active {
            background-color: #03004d;
            color: #ffffff;
          }
        }
      }
    }
    .set-type-content {
      min-width: 1018px;
      padding: 20px;
      margin-left: 10px;
      border-radius: 12px 12px 12px 12px;
      background-color: #ffffff;
    }
  }
}
</style>
